// extracted by mini-css-extract-plugin
export var heading = "styles-module--heading--79117";
export var layout = "styles-module--layout--45345";
export var link = "styles-module--link--e1396";